<div nz-row>
    <ng-container *ngIf="isReverification; else initialVerification">
        <div class="reverification-column" nz-col [nzSm]="{span: 24}" [nzMd]="{span: 24}" [nzLg]="{span: 24}">
            <ng-container *ngIf="tokenVerificationFailed && !email; else recurringCard">
                <ng-container *ngTemplateOutlet="tokenFailure"></ng-container>
            </ng-container>

            <ng-template #recurringCard>
                <nz-card *ngIf="!isVerifyingEmail; else verifyingBox" class="reverification-card" [attr.aria-busy]="state === 'sending'">
                    <section class="reverification-content">
                        <h1 #reverificationTitle class="reverification-title" tabindex="-1">Verify Your Email Address</h1>

                        <span class="reverification-copy">
                            For your security, please verify your email address again.<br/>
                            We ask users to do this every 90 days.
                            <br/><br/>
                        </span>
                        <span *ngIf="state === 'sending'" class="reverification-copy" role="status" aria-live="polite">
                            <span nz-icon nzType="loading" nzTheme="outline" aria-hidden="true"></span>
                            Sending your verification email. Please wait.
                        </span>
                        <span *ngIf="state === 'sent'" class="reverification-copy" role="status" aria-live="polite">
                            We’ve sent a verification email to your inbox.<br/>
                            Please open the email and complete verification. You can then return to the log in screen.
                        </span>
                        <span *ngIf="state === 'failed'" class="reverification-copy reverification-error" role="alert">
                            {{failureMessage}}
                        </span>

                        <div class="reverification-actions">
                            <button
                                class="hill-button-secondary"
                                type="button"
                                [disabled]="state === 'sending' || state === 'verifying'"
                                (click)="onReSendEmail()">
                                Didn’t get the email? Click here to re-send the confirmation
                            </button>
                            <button class="hill-button-secondary-outline reverification-back" type="button" (click)="goToLogin()">
                                Go Back
                            </button>
                        </div>
                    </section>
                </nz-card>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #initialVerification>
        <div nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
            <ng-container *ngIf="tokenVerificationFailed && !email; else initialCard">
                <ng-container *ngTemplateOutlet="tokenFailure"></ng-container>
            </ng-container>

            <ng-template #initialCard>
                <nz-card *ngIf="!isVerifying && !isVerifyingEmail; else verifyingBox">
                    <nz-result
                        nzStatus="info"
                        nzTitle="Verify Your Email Address"
                        [nzSubTitle]="emailVerifyMessage">
                        <ng-template #emailVerifyMessage>
                            <span *ngIf="email; else noEmailMessage">
                                Please verify your email address <strong>{{email}}</strong> before logging in.
                                Check your email for a verification link.<br/><br/>
                                <a style="cursor: pointer; text-decoration: underline;" (click)="onReSendEmail()">Didn't
                                get the email? Click here to re-send the confirmation.</a>
                            </span>
                            <ng-template #noEmailMessage>
                                Please check your email for a verification link to complete your account setup.
                            </ng-template>
                        </ng-template>
                        <div nz-result-extra>
                            <button nz-button nzType="default" type="button" (click)="goToLogin()">Back to Login</button>
                        </div>
                    </nz-result>
                    <ng-template #noDetails>
                        <nz-result
                            nzStatus="error"
                            nzTitle="No Account Details Found">
                        </nz-result>
                    </ng-template>
                </nz-card>
            </ng-template>
        </div>
    </ng-template>

    <ng-template #tokenFailure>
        <nz-card>
            <nz-result
                nzStatus="error"
                nzTitle="Email Verification Failed"
                [nzSubTitle]="failureMessage">
                <div nz-result-extra>
                    <button nz-button nzType="default" type="button" (click)="goToLogin()">Back to Login</button>
                </div>
            </nz-result>
        </nz-card>
    </ng-template>

    <ng-template #verifyingBox>
        <nz-card>
            <nz-result
                nzStatus="info"
                [nzTitle]="isVerifyingEmail ? 'Verifying Email Address' : 'Verify Your Account'"
                [nzSubTitle]="verifyingMessage">
                <ng-template #verifyingMessage>
                    <i nz-icon nzType="icons/fontawesome/solid:circle-notch" nzSpin></i>
                    {{ isVerifyingEmail ? 'Verifying your email address... Please wait.' : 'Checking if your account is verified' }}
                </ng-template>
            </nz-result>
        </nz-card>
    </ng-template>
</div>
